import { useEffect, useRef } from "react";
import moment from "moment";
import { getTradeAssistant } from "../../redux/trading-assistant/actions";
import { useDispatch, useSelector } from "react-redux";
import useServiceStatus from "../useServiceStatus";

const BOARD_REFRESH_MINUTES = 15;

const useRefreshSignals = (signalSource = "") => {
  const {
    tradingAssistant: {
      tradeAssistant: { signal_timestamp, generated_at } = {},
      aiMarketType,
      selectedPortfolio,
      aiAssistantMode,
    },
    main: { userData },
  } = useSelector((state) => state);

  const signalTimestamp =
    signalSource === "ai" ? signal_timestamp || generated_at : "";

  const dispatch = useDispatch();
  const { isActive: isAiActive } = useServiceStatus("aiAssistant");
  const refreshLock = useRef(0);

  useEffect(() => {
    if (signalSource !== "ai" || !userData?.email || !isAiActive) return;

    const checkTime = () => {
      if (Date.now() < refreshLock.current) return;
      if (!signalTimestamp) return;
      const signalTime = moment.utc(signalTimestamp).local();
      const diffInMinutes = moment().diff(signalTime, "minutes");
      if (diffInMinutes < BOARD_REFRESH_MINUTES) return;
      refreshLock.current = Date.now() + BOARD_REFRESH_MINUTES * 60 * 1000;
      dispatch(
        getTradeAssistant(
          userData?.["cognito:username"],
          userData?.["custom:custom_username"],
          (selectedPortfolio || "primary").toLowerCase(),
          aiMarketType,
          isAiActive,
          aiAssistantMode,
        ),
      );
    };

    checkTime();
    const intervalId = setInterval(checkTime, 60 * 1000);
    return () => clearInterval(intervalId);
  }, [
    signalTimestamp,
    signalSource,
    userData,
    dispatch,
    selectedPortfolio,
    aiMarketType,
    isAiActive,
    aiAssistantMode,
  ]);
};

export default useRefreshSignals;
